import { makeVar } from "@apollo/client";
import { createContext } from "react";

export type ChatSessionFunctionCallType = {
  chatSessionId: number;
  functionName: string;
  parameters?: any;
} | null;

export const chatSessionFunctionCallVar =
  makeVar<ChatSessionFunctionCallType>(null);

export const ChatSessionContext = createContext<{
  assessmentId?: number;
  assessmentQuestionId?: number;
  meetingId?: number;
  currentSuggestedAssessmentResponseId?: string | null;
  setCurrentSuggestedAssessmentResponseId?: (id: string | null) => void;
}>({
  assessmentId: undefined,
  assessmentQuestionId: undefined,
  meetingId: undefined,
  currentSuggestedAssessmentResponseId: null,
  setCurrentSuggestedAssessmentResponseId: undefined,
});
